"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumNetNameCollisionFinalizingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
const compareAltiumPinReferences_1 = require("./compareAltiumPinReferences");
class AltiumNetNameCollisionFinalizingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Finalize;
    }
    apply(groups, _hierarchy) {
        const groupsByName = new Map();
        for (const group of groups) {
            if (!group.physicalName) {
                continue;
            }
            const sameNameGroups = groupsByName.get(group.physicalName) ?? [];
            sameNameGroups.push(group);
            groupsByName.set(group.physicalName, sameNameGroups);
        }
        for (const [name, sameNameGroups] of groupsByName) {
            if (sameNameGroups.length < 2 || !sameNameGroups.some((group) => this.hasNetLabelNamed(group, name))) {
                continue;
            }
            for (const group of sameNameGroups) {
                if (this.hasNetLabelNamed(group, name)) {
                    continue;
                }
                if (!this.hasSheetEntryNamed(group, name)) {
                    continue;
                }
                const fallbackName = this.getComponentConnectionName(group);
                if (fallbackName) {
                    group.physicalName = fallbackName;
                }
            }
        }
    }
    hasNetLabelNamed(group, name) {
        return group.getNetLabels().some((label) => {
            if (label.labelType !== 'net-label') {
                return false;
            }
            const labelName = label.formattedLabel ?? label.originalLabel;
            return AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.maybeDereferenceLabelName(labelName) === name;
        });
    }
    hasSheetEntryNamed(group, name) {
        return group.getNetLabels().some((label) => {
            if (label.labelType !== 'sheet-entry') {
                return false;
            }
            if (label.strategyMetadata?.harness?.harnessSource === 'synthetic-sheet-entry') {
                return false;
            }
            const labelName = label.formattedLabel ?? label.originalLabel;
            return AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.maybeDereferenceLabelName(labelName) === name;
        });
    }
    getComponentConnectionName(group) {
        const connections = [];
        for (const [_instance, nets] of group.getNets()) {
            for (const net of nets) {
                for (const conn of net.connections) {
                    connections.push({
                        moduleName: conn.connection.moduleName,
                        pinRef: conn.connection.pinRef,
                    });
                }
            }
        }
        if (connections.length === 0) {
            return undefined;
        }
        connections.sort((a, b) => {
            const moduleCompare = sigma_engine_shared_1.Utils.naturalStringSort(a.moduleName, b.moduleName);
            if (moduleCompare !== 0) {
                return moduleCompare;
            }
            return (0, compareAltiumPinReferences_1.compareAltiumPinReferences)(a.pinRef, b.pinRef);
        });
        const firstConn = connections[0];
        return `Net${firstConn.moduleName}_${firstConn.pinRef}`;
    }
}
exports.AltiumNetNameCollisionFinalizingRule = AltiumNetNameCollisionFinalizingRule;
//# sourceMappingURL=AltiumNetNameCollisionFinalizingRule.js.map